/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCouponRedemptionData
 */
export interface CreateCouponRedemptionData {
    /**
     * 
     * @type {string}
     * @memberof CreateCouponRedemptionData
     */
    code?: string;
}

/**
 * Check if a given object implements the CreateCouponRedemptionData interface.
 */
export function instanceOfCreateCouponRedemptionData(value: object): value is CreateCouponRedemptionData {
    return true;
}

export function CreateCouponRedemptionDataFromJSON(json: any): CreateCouponRedemptionData {
    return CreateCouponRedemptionDataFromJSONTyped(json, false);
}

export function CreateCouponRedemptionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCouponRedemptionData {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
    };
}

  export function CreateCouponRedemptionDataToJSON(json: any): CreateCouponRedemptionData {
      return CreateCouponRedemptionDataToJSONTyped(json, false);
  }

  export function CreateCouponRedemptionDataToJSONTyped(value?: CreateCouponRedemptionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

